(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ── Predictive Search ──
  (function () {
    const input = document.getElementById('header-inline-search');
    const dropdown = document.getElementById('header-search-suggestions');
    if (!input || !dropdown) return;

    let debounceTimer;

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderResults(data, query) {
      dropdown.innerHTML = '';
      const resources = data.resources.results;
      const products = resources.products || [];
      const queries = resources.queries || [];
      const pages = resources.pages || [];

      if (!products.length && !queries.length && !pages.length) {
        dropdown.classList.remove('is-open');
        return;
      }

      if (queries.length) {
        const heading = document.createElement('div');
        heading.className = 'search-suggestions-heading';
        heading.textContent = 'Suggestions';
        dropdown.appendChild(heading);
        queries.slice(0, 3).forEach(q => {
          const a = document.createElement('a');
          a.className = 'search-suggestion-item';
          a.href = '/search?q=' + encodeURIComponent(q.text);
          a.innerHTML = `
            <div class="search-suggestion-item__no-image" style="display:flex;align-items:center;justify-content:center;font-size:1.1rem;opacity:0.4;">🔍</div>
            <div class="search-suggestion-item__info">
              <span class="search-suggestion-item__title">${q.styled_text || q.text}</span>
            </div>`;
          dropdown.appendChild(a);
        });
      }

      if (products.length) {
        const heading = document.createElement('div');
        heading.className = 'search-suggestions-heading';
        heading.textContent = 'Products';
        dropdown.appendChild(heading);
        products.slice(0, 4).forEach(product => {
          const a = document.createElement('a');
          a.className = 'search-suggestion-item';
          a.href = product.url;
          const imgHTML = product.featured_image?.url
            ? `<img src="${product.featured_image.url}&width=96" alt="${product.title}">`
            : `<div class="search-suggestion-item__no-image"></div>`;
          const price = product.price ? `<span class="search-suggestion-item__price">${window.Shopify?.currency?.active || ''} ${formatMoney(product.price)}</span>` : '';
          a.innerHTML = `${imgHTML}<div class="search-suggestion-item__info"><span class="search-suggestion-item__title">${product.title}</span>${price}</div>`;
          dropdown.appendChild(a);
        });
      }

      if (pages.length) {
        const heading = document.createElement('div');
        heading.className = 'search-suggestions-heading';
        heading.textContent = 'Pages';
        dropdown.appendChild(heading);
        pages.slice(0, 2).forEach(page => {
          const a = document.createElement('a');
          a.className = 'search-suggestion-item';
          a.href = page.url;
          a.innerHTML = `
            <div class="search-suggestion-item__no-image" style="display:flex;align-items:center;justify-content:center;font-size:1.1rem;opacity:0.4;">📄</div>
            <div class="search-suggestion-item__info">
              <span class="search-suggestion-item__title">${page.title}</span>
              <span class="search-suggestion-item__type">Page</span>
            </div>`;
          dropdown.appendChild(a);
        });
      }

      const viewAll = document.createElement('a');
      viewAll.className = 'search-suggestion-view-all';
      viewAll.href = '/search?q=' + encodeURIComponent(query);
      viewAll.textContent = 'View all results →';
      dropdown.appendChild(viewAll);
      dropdown.classList.add('is-open');
    }

    async function fetchSuggestions(query) {
      if (query.length < 2) {
        dropdown.classList.remove('is-open');
        return;
      }
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,query,page&resources[limit]=6&resources[options][unavailable_products]=last`);
        const data = await res.json();
        renderResults(data, query);
      } catch (e) {
        dropdown.classList.remove('is-open');
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fetchSuggestions(this.value.trim()), 250);
    });

    document.addEventListener('click', function (e) {
      if (!input.closest('.header__search-inline').contains(e.target)) {
        dropdown.classList.remove('is-open');
      }
    });

    input.addEventListener('keydown', function (e) {
      const items = dropdown.querySelectorAll('.search-suggestion-item, .search-suggestion-view-all');
      const current = dropdown.querySelector('[aria-selected="true"]');
      let index = Array.from(items).indexOf(current);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (current) current.removeAttribute('aria-selected');
        index = (index + 1) % items.length;
        items[index].setAttribute('aria-selected', 'true');
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (current) current.removeAttribute('aria-selected');
        index = (index - 1 + items.length) % items.length;
        items[index].setAttribute('aria-selected', 'true');
      } else if (e.key === 'Escape') {
        dropdown.classList.remove('is-open');
        input.blur();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
